import { render } from "./LoaderFullScreen.vue?vue&type=template&id=2c4545f8&scoped=true"
import script from "./LoaderFullScreen.vue?vue&type=script&lang=js"
export * from "./LoaderFullScreen.vue?vue&type=script&lang=js"

import "./LoaderFullScreen.vue?vue&type=style&index=0&id=2c4545f8&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4545f8"]])

export default __exports__